import { openApi } from '@/api/MediaCenter/request'

export default {
  checkUser (mobile) {
    return openApi.post('/Rccl.OpenApi/NewsFileList/CheckUser', { mobile })
  },
  login (requestData) {
    return openApi.post('/Rccl.OpenApi/NewsFileList/LoginHP', requestData)
  },
  getHomeContent () {
    return openApi.get('/Rccl.OpenApi/NewsFileList/GetHomeContent')
  },
  getDetail (data) {
    return openApi.post('/Rccl.OpenApi/NewsFileList/Detail', data)
  },
  getNews (data) {
    return openApi.post('/Rccl.OpenApi/NewsFileList/GetNews', data)
  }
}
